import { observer } from 'mobx-react-lite';
import { createContext, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import 'reflect-metadata';

import { MFErrorText } from '~/components/reuseable/MFErrorText';

import { useMFBaseContext } from '../hooks/useMFBaseContext';
import { MFBaseContextPropsType } from './MFBaseProvider';

export type MFSurveyFormContextPropsType = MFBaseContextPropsType & {
  carId?: string;
  workOrderId?: string;
  apiUrl?: string;
  showResults?: boolean;
  isWebView?: boolean;
  onSave?: () => void;
  cardHeader?: ReactNode;
  disableResults?: boolean;
};

export type MFSurveyFormProviderPropsType = MFSurveyFormContextPropsType & {
  children: ReactNode;
};

export const MFSurveyFormContext = createContext<MFSurveyFormContextPropsType | undefined>(undefined);

// Типы не передаются в родительские проекты, поэтому определяем обязательные пропы
const requiredProps: Partial<keyof MFSurveyFormContextPropsType>[] = [
  // TODO
  // 'onEdit',
];

export const MFSurveyFormProvider: FC<MFSurveyFormProviderPropsType> = observer((props) => {
  const mfBaseContext = useMFBaseContext();
  const { t } = useTranslation('common');

  if (requiredProps.some((prop) => props[prop as keyof MFSurveyFormContextPropsType] === undefined)) {
    console.log(t('error.requiredPropsNotFound'));

    return <MFErrorText />;
  }

  const contextValue = {
    ...mfBaseContext, // унаследуем базовый контекст
    ...props,
  };

  return <MFSurveyFormContext.Provider value={contextValue}>{props.children}</MFSurveyFormContext.Provider>;
});
